import { API, authClient } from "../index";

export const getObraHeaders = (accessToken) => {
  return authClient(accessToken).get(`${API}/obra-headers`);
};

export const getObraHeaderById = (id, accessToken) => {
  return authClient(accessToken).get(`${API}/obra-headers/${id}`);
};

export const getAvailableOfferHeadersForObra = (accessToken) => {
  return authClient(accessToken).get(`${API}/obra-headers/available-offers`);
};

export const postObraHeaderFromOffer = (offerId, obraData, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/from-offer/${offerId}`,
    obraData
  );
};

export const updateObraHeader = (id, obraHeader, accessToken) => {
  return authClient(accessToken).put(`${API}/obra-headers/${id}`, obraHeader);
};

export const deleteObraHeader = (id, accessToken) => {
  return authClient(accessToken).delete(`${API}/obra-headers/${id}`);
};

export const assignOperarioToObra = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}`
  );
};

export const removeOperarioFromObra = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}`
  );
};

export const blockOperarioInObra = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/block`
  );
};

export const unblockOperarioInObra = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/unblock`
  );
};

export const updateObraHitos = (obraId, hitosData, accessToken) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/hitos`,
    hitosData
  );
};

export const getObraMaterialRequests = (obraId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/material-requests`
  );
};

export const getObraMaterialRequestEditor = (
  obraId,
  requestId,
  accessToken
) => {
  const suffix = requestId ? `?solicitudId=${requestId}` : "";
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/material-requests/editor${suffix}`
  );
};

export const postObraMaterialRequest = (obraId, requestData, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/material-requests`,
    requestData
  );
};

export const updateObraMaterialRequest = (
  obraId,
  requestId,
  requestData,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/material-requests/${requestId}`,
    requestData
  );
};

export const updateObraMaterialRequestStatus = (
  obraId,
  requestId,
  statusData,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/material-requests/${requestId}/status`,
    statusData
  );
};

export const postObraOperarioHours = (
  obraId,
  operarioId,
  hoursData,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/hours`,
    hoursData
  );
};

export const getObraOperarioHours = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/hours`
  );
};

export const getObraOperarioTaskHours = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/task-hours`
  );
};

export const updateObraProductCompletion = (
  obraId,
  chapterId,
  partidaId,
  productId,
  completed,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/chapters/${chapterId}/partidas/${partidaId}/products/${productId}/completion`,
    { completado: completed }
  );
};

export const deleteObraMaterialRequest = (obraId, requestId, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/material-requests/${requestId}`
  );
};

export const getObraSupplierRequests = (obraId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-requests`
  );
};

export const getObraSupplierRequestEditor = (obraId, requestId, accessToken) => {
  const suffix = requestId ? `?requestId=${requestId}` : "";
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-requests/editor${suffix}`
  );
};

export const getObraSupplierRequestById = (obraId, requestId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}`
  );
};

export const getObraOperarioTaskReportEditor = (obraId, operarioId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/task-report/editor`
  );
};

export const postObraOperarioTaskReport = (obraId, operarioId, reportData, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/task-reports`,
    reportData
  );
};

export const postObraOperarioTaskAssistant = (obraId, operarioId, data, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/task-assistant`,
    data
  );
};

export const postObraOperarioTaskAssistantAudio = (obraId, operarioId, files, context, accessToken) => {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append("files", file, `parte-${index + 1}.webm`);
  });
  if (context?.conclusion_anterior) formData.append("conclusion_anterior", context.conclusion_anterior);
  if (context?.historial?.length) formData.append("historial_json", JSON.stringify(context.historial));
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/operarios/${operarioId}/task-assistant/audio`,
    formData
  );
};

export const getObraTaskReports = (obraId, accessToken) => {
  return authClient(accessToken).get(`${API}/obra-headers/${obraId}/task-reports`);
};

export const deleteObraTaskReport = (obraId, reportId, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/task-reports/${reportId}`
  );
};

export const deleteObraTaskReportLine = (obraId, reportId, lineId, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/task-reports/${reportId}/lines/${lineId}`
  );
};

export const getObraSupplierRequestMailHistory = (obraId, requestId, accessToken) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/mail-history`
  );
};

export const markObraSupplierRequestMailAsReviewed = (
  obraId,
  requestId,
  mailId,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/mail-history/${mailId}/review`
  );
};

export const postObraSupplierRequest = (obraId, requestData, accessToken) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/supplier-requests`,
    requestData
  );
};

export const updateObraSupplierRequest = (
  obraId,
  requestId,
  requestData,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}`,
    requestData
  );
};

export const deleteObraSupplierRequest = (obraId, requestId, accessToken) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}`
  );
};

export const deleteObraSupplierRequestGroup = (
  obraId,
  groupId,
  accessToken
) => {
  return authClient(accessToken).delete(
    `${API}/obra-headers/${obraId}/supplier-request-groups/${groupId}`
  );
};

export const getObraSupplierRequestBudgetSelection = (
  obraId,
  groupId,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-request-groups/${groupId}/budget-selection`
  );
};

export const generateObraPurchaseOrders = (
  obraId,
  groupId,
  payload,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/supplier-request-groups/${groupId}/generate-orders`,
    payload
  );
};

export const getObraPurchaseOrders = (obraId, accessToken) => {
  return authClient(accessToken).get(`${API}/obra-headers/${obraId}/purchase-orders`);
};

export const addSupplierToObraSupplierRequestGroup = (
  obraId,
  groupId,
  supplierId,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/supplier-request-groups/${groupId}/suppliers`,
    { proveedor_id: supplierId }
  );
};

export const getObraPurchaseOrder = (obraId, orderId, accessToken) =>
  authClient(accessToken).get(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}`);

export const updateObraPurchaseOrder = (obraId, orderId, payload, accessToken) =>
  authClient(accessToken).put(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}`, payload);

export const previewObraPurchaseOrderPdf = (obraId, orderId, accessToken) =>
  authClient(accessToken).get(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}/pdf`, { responseType: "blob" });

export const sendObraPurchaseOrder = (obraId, orderId, accessToken) =>
  authClient(accessToken).post(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}/send`);

export const getObraPurchaseOrderReceiptEditor = (obraId, orderId, accessToken) =>
  authClient(accessToken).get(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}/receipt-editor`);

export const postObraPurchaseOrderReceipt = (obraId, orderId, payload, accessToken) =>
  authClient(accessToken).post(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}/receipts`, payload);

export const analyzeObraPurchaseOrderDeliveryNote = (obraId, orderId, file, accessToken) => {
  const formData = new FormData();
  formData.append("file", file);
  return authClient(accessToken).post(`${API}/obra-headers/${obraId}/purchase-orders/${orderId}/delivery-note/analyze`, formData);
};

export const deleteObraPurchaseOrderReceipt = (obraId, receiptId, accessToken) =>
  authClient(accessToken).delete(`${API}/obra-headers/${obraId}/purchase-orders/receipts/${receiptId}`);

export const getObraMaterialAssignmentEditor = (obraId, accessToken) =>
  authClient(accessToken).get(`${API}/obra-headers/${obraId}/material-assignments/editor`);

export const postObraMaterialAssignments = (obraId, payload, accessToken) =>
  authClient(accessToken).post(`${API}/obra-headers/${obraId}/material-assignments`, payload);

export const sendObraSupplierRequestMail = (
  obraId,
  requestId,
  payload,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/send-mail`,
    payload
  );
};

export const updateObraSupplierRequestStatus = (
  obraId,
  requestId,
  statusData,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/status`,
    statusData
  );
};

export const getObraSupplierRequestResponse = (
  obraId,
  requestId,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/response`
  );
};

export const updateObraSupplierRequestResponse = (
  obraId,
  requestId,
  responseData,
  accessToken
) => {
  return authClient(accessToken).put(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/response`,
    responseData
  );
};

export const autoFillObraSupplierRequestResponse = (
  obraId,
  requestId,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/obra-headers/${obraId}/supplier-requests/${requestId}/response/auto`
  );
};
